import { concatMap, interval, Subscription, switchMap } from 'rxjs';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HttpInsuranceProductService } from '../../../../../service/http-insurance-product.service';
import { ScheduleUploadStatusDto } from '../../../../../service/dto-insurance';

@Component({
  selector: 'app-finance-product-schedule-progress',
  standalone: false,
  templateUrl: './finance-product-schedule-progress.component.html',
  styleUrl: './finance-product-schedule-progress.component.scss'
})
export class FinanceProductScheduleProgressComponent implements OnInit,OnDestroy{
	@Input() scheduleId!: number;
	data?: ScheduleUploadStatusDto;
	subscription = new Subscription();
	constructor(private service: HttpInsuranceProductService){

	}
	ngOnInit(): void {
		interval(500).pipe(
			concatMap(()=> this.service.getScheduleUploadStats(this.scheduleId))
		).subscribe(result => {
			this.data=result;
		})
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
